export const SalesData = "SalesData";
export const SelfInspecData = "SelfInspecData";
export const profileDetails = "profileDetails";
export const pendingCasesData = "pendingCases";
export const UserIdManagement = "UserIdManagement";
export const LOGINDATA = "LOGINDATA";
export const BRANCHDATA = "BRANCHDATA";
export const SingleRow = "SingleRow";
export const NEWEMPLOYEE = "NEWEMPLOYEE";
export const RenewalNotification = "RenewalNotification";
export const RENEWALS = "RENEWALS";
export const Other_Payouts = "Other_Payouts";
export const TOGGLE_FORM = "TOGGLE_FORM";
export const TOGGLE_PANNEL = "TOGGLE_PANNEL";
export const Employee_Logout = "EMPLOYEE_LOGOUT";
export const EMPLOYEE_LOGIN_REPORTS = "EMPLOYEE_LOGIN_REPORTS";
export const EMPLOYEE_PENDING_REPORT = "EMPLOYEE_PENDING_REPORT";
export const EMPLOYEE_ISSUE_REPORT = "EMPLOYEE_ISSUE_REPORT";
export const EMPLOYEE_REJECTED_REPORT = "EMPLOYEE_REJECTED_REPORT";
export const EMPLOYEE_RECONCILIATION_REPORT = "EMPLOYEE_RECONCILIATION_REPORT";
export const UPDATE_LOGIN_REPORTS = "UPDATE_LOGIN_REPORTS";
export const COMPANY_REVENUE = "COMPANY_REVENUE";
export const COMPANY_PRODUCT_TYPE = "COMPANY_PRODUCT_TYPE";
export const POSP_REVENUE = "POSP_REVENUE";
export const EMPLOYEE_REVENUE = "EMPLOYEE_REVENUE";
export const BRANCHES_LIST = "BRANCHES_LIST";
export const POLICY_REPORTS = "POLICY_REPORTS";
export const EMPLOYEE_LOOKUP_REPORTS = "EMPLOYEE_LOOKUP_REPORTS";
